import React from "react";
import { Button, Col, Row } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import moment from "moment";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

const AnnouncementsTable = ({
  tableData,
  defaultSorted,
  forceUpdate: _forceUpdate,
  setForce: _setForce,
  searchQuery,
  onView,
}) => {
  const { ExportCSVButton } = CSVExport;

  const dismissedFormatter = (cell, row) => (
    <>
      {row.is_dismissed ? (
        <span className="text-success fas fa-check-circle" style={{ fontSize: "1.2rem" }} />
      ) : (
        <span className="text-danger fas fa-times-circle" style={{ fontSize: "1.2rem" }} />
      )}
    </>
  );

  const statusFormatter = (cell, row) => (
    <>
      {row.is_read ? (
        <Button className="btn-status-big" disabled color="success">
          Read
        </Button>
      ) : (
        <Button className="btn-status-big" disabled color="primary">
          Unread
        </Button>
      )}
    </>
  );

  const statusCsvFormatter = cell => (cell ? "Read" : "Unread");
  const dismissedCsvFormatter = cell => (cell ? "Dismissed" : "Not Dismissed");

  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format("YYYY-MM-DD")
    );
  };

  const actionFormatter = (cell, row) => (
    <Button className="btn btn-outline-primary" onClick={() => onView(row)}>
      View
    </Button>
  );

  const columns = [
    {
      dataField: "title",
      text: "Title",
      sort: false,
      formatter: cell => <span className="fontWeight700">{cell || "—"}</span>,
      headerStyle: () => ({ width: "150px" }),
    },
    {
      dataField: "created",
      text: "Date Posted",
      sort: false,
      formatter: dateFormatter,
      headerStyle: () => ({ width: "70px" }),
    },
    {
      dataField: "is_dismissed",
      text: "Dismissed",
      sort: false,
      formatter: dismissedFormatter,
      csvFormatter: dismissedCsvFormatter,
      headerStyle: () => ({ width: "60px" }),
    },
    {
      dataField: "is_read",
      text: "Status",
      sort: false,
      formatter: statusFormatter,
      csvFormatter: statusCsvFormatter,
      headerStyle: () => ({ width: "60px" }),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: () => ({ width: "30px" }),
    },
  ];

  const handleTableChange = (type, { sortField, sortOrder }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "title" || sortField === "created" || sortField === "is_read") {
      searchQuery.setOrdering({ order: ascDesc, name: sortField, sort: sortField });
    }
  };

  return (
    <ToolkitProvider
      keyField="tableKey"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true,
      }}
      exportCSV={{
        fileName: "announcements.csv",
      }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="flexEndContainer mb-3">
                <ExportCSVButton className="btn btn-outline-info" {...props.csvProps}>
                  Export CSV
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            defaultSorted={defaultSorted}
            remote={{ sort: true }}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default AnnouncementsTable;
